export default __webpack_public_path__ + "static/media/banner.f8135b57.png";